import { Outlet } from "react-router-dom";
import { Layout } from "antd";
import MainHeader from "./header";
import MainSider from "./sider";
import MainBreadCrumb from "./breadcrumb";

export const MainLayout = () => {
  const { Content, Footer } = Layout;

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <MainSider />
      <Layout className="site-layout">
        <MainHeader />
        <Content className="bg-gray-50">
          <MainBreadCrumb />
          <div className="site-layout-background p-4" style={{ height: "calc(100vh - 142px)", overflowY: "auto" }}>
            <Outlet />
          </div>
        </Content>
        <Footer className="p-2 m-0 bg-gray-100 border-t border-gray-200" style={{ borderTopStyle: "solid" }}>
          پنل مدیریت بونیبو
        </Footer>
      </Layout>
    </Layout>
  );
};
